import type { ApiResponse } from "@/types/apis";
import request from "@/utils/request";

// ==================== 类型定义 ====================

/**
 * 企业微信参数响应
 * /wecom/generate 返回的参数用于前端生成二维码
 */
export interface WecomQRCodeResponse {
  /**
   * 企业微信代理ID
   */
  agentId: string;
  /**
   * 企业微信CorpId
   */
  corpId: string;
  /**
   * 有效期（毫秒）
   */
  expiresAt: number;
  /**
   * 重定向URI
   */
  redirectUri: string;
  /**
   * 状态参数（流程编号）
   */
  state: string;
}

// ==================== API 接口 ====================

/**
 * 获取企业微信参数，用于前端生成二维码
 * GET /wecom/generate
 *
 * 返回企业微信的相关参数，前端使用这些参数生成二维码
 * @returns 企业微信参数数据
 */
export const generateWecomQRCode = () =>
  request.get<ApiResponse<WecomQRCodeResponse>>("/wecom/generate");

/**
 * 验证企业微信回调信息
 * POST /wecom/callback
 *
 * @param data 回调数据（code 和 state）
 * @returns 验证结果
 */
export const verifyWecomCallback = (data: { code: string; state: string }) =>
  request.post<ApiResponse<{ userId: string; userName: string }>>(
    "/wecom/callback",
    data,
  );
